import { Paper, Tabs } from "@mantine/core";
import { useState } from "react";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import DuplicateCheck from "./DuplicateCheck";
const TabDuplicateReport = () => {
  const [activeTab, setActiveTab] = useState<string | null>("1");

  return (
    <>
      <div>
        <BreadcrumbLayout1></BreadcrumbLayout1>
      </div>
      <Paper shadow="md" radius="lg">
        <Tabs p={"xs"} value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="1">Check trùng mã phiếu thu chi, báo có</Tabs.Tab>
            <Tabs.Tab value="2">
              Check trùng phiếu nhập, xuất cho đơn hàng,đơn DT
            </Tabs.Tab>
            <Tabs.Tab value="3">Check xóa nhân viên</Tabs.Tab>
            <Tabs.Tab value="4">
              Check đơn hàng không thấy người bán, người tạo, người hưởng
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="1">
            {activeTab === "1" ? (
              <DuplicateCheck duplicateCheckKey={1} />
            ) : (
              <></>
            )}
          </Tabs.Panel>
          <Tabs.Panel value="2">
            {activeTab === "2" ? (
              <DuplicateCheck duplicateCheckKey={2} />
            ) : (
              <></>
            )}
          </Tabs.Panel>
          <Tabs.Panel value="3">
            {activeTab === "3" ? (
              <DuplicateCheck duplicateCheckKey={3} />
            ) : (
              <></>
            )}
          </Tabs.Panel>
          <Tabs.Panel value="4">
            {activeTab === "4" ? (
              <DuplicateCheck duplicateCheckKey={4} />
            ) : (
              <></>
            )}
          </Tabs.Panel>
        </Tabs>
      </Paper>
    </>
  );
};

export default TabDuplicateReport;
